// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3_oCqVy1ioNEsg4UwoSZh6","title":"Q585d0FusbfxFYiQced-R","cardsWrapper":"_1gAR9MRnY2lPglg6iNFcaS","cards":"_2AYsFYpINLDNExXN5lLIIp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ArticlesRead/ArticlesRead.scss
// module id = 1556
// module chunks = 0